import { useParams } from 'react-router-dom';
import Rating from '../components/Rating';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import NotFound from './NotFound';
import bookList from '../BookList';

export default function Product({results, addToCart}) {

    const target = useParams().productId;
    const featuredList = [
        {id: 'ftbid1'},
        {id: 'ftbid2'},
        {id: 'ftbid3'},
        {id: 'ftbid4'}
    ];

    const filter = container => container.filter(item => item.id !== target);
    const search = container => container.find(  item => item.id === target);
    let others = filter(results);
    let featured = false;

    const item = (search(featuredList)) ? ((
        featured = true,
        others = filter(bookList),
        search(bookList))
    ) : (
        search(results)
    );

    const [added, setAdded] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [target]);
    
    const handleClick = () => {
        addToCart(item);
        if (!added) setAdded(true);
    }
    return (
        <main className={`product-container ${featured ? `featured ${item.id}` : ''}`}>
            {item ? (<>

                <div className={`product-bg ${featured ? item.id : ''}`}></div>
                <Navbar />
                <section className='product-top'>
                    <img src={item.image} alt={item.title}/>
                    <div className='item-info'>
                        <p className='book-title'>{item.title}</p>
                        <p className='book-author'>By {item.author}</p>
                        <Rating classes={'justify-left'} rating={item.rating}/>
                        <p className='book-price'>${item.price}</p>
                        <p>Category: {item.genre}</p>
                        <p>{item.length} Pages</p>
                        <button
                            onClick={() => handleClick()}
                            className={`product-add-btn ${added ? 'added' : ''}`}>

                            {added ? 'Added': 'Add To Cart'}
                        </button>
                    </div>
                </section>
                <section className='product-bottom'>
                    <h2>Description</h2>
                    <p>{item.desc}</p>
                </section>
                <section className='more-like-this'>
                    {featured ? (
                        <h2>More Featured Books</h2>
                    ) : (
                        <h2>More Like This</h2>
                    )}
                    <div className='related-results'>
                        {others.map(item =>
                            <Link
                                to={`/products/${item.id}`}
                                key={item.id}
                                className='product-suggestion'
                                onClick={() => setAdded(false)}
                                >
                                <img src={item.image} alt={item.title} />
                                <p className='book-title'>{item.title}</p>
                                <p className='book-author'>By {item.author}</p>
                                <Rating classes={''} rating={item.rating} />
                                <p className='book-price'>${(item.price).toFixed(2)}</p>
                            </Link>
                        )}

                    </div>
                    
                </section>
                <Footer />
            </>) : (
                <NotFound />
            )}
        </main>
    )
    

}
